export default __webpack_public_path__ + "static/media/WhiteSpinner.3ce2df4d.svg";